














import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.attic.surface",
        };
    },
    computed: {
        floorAreaAttic: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        hasAttic: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.attic.exists");
        }
    },
    methods: {
        updateValue: function(floorAreaAttic: number): void {
            if (!this.hasAttic || (floorAreaAttic == 0 && this.floorAreaAttic != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorAreaAttic});
            }
        }
    }
});

